import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
// import './index.css';

const Activities = React.lazy(() => import(/* webpackChunkName: 'activities' */ './App'));
const Leagues = React.lazy(() => import(/* webpackChunkName: 'leagues' */ './Leagues'));

ReactDOM.render(
    <BrowserRouter>
        <React.Suspense fallback={'Loading...'}>
            {
                typeof window.TEAMS !== 'undefined'
                    ? <Leagues/>
                    : <Activities/>
            }
        </React.Suspense>
    </BrowserRouter>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
